var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "wz_wrapChips" },
    [
      _vm.datasVisiteur.nb_alert
        ? _c(
            "v-flex",
            { staticClass: "visiteurFiltrer", attrs: { xs12: "", sm12: "" } },
            [
              _c(
                "v-list-tile",
                {
                  key: _vm.datasVisiteur.status,
                  class: {
                    "light-blue lighten-4":
                      _vm.visSelectId == _vm.datasVisiteur.visiteurID
                  },
                  attrs: { ripple: "" },
                  on: { click: _vm.checkChatVisiteur }
                },
                [
                  !_vm.dejaEnChat && !_vm.datasVisiteur.network
                    ? _c("wz-avatar", {
                        staticClass: "pl-1",
                        attrs: {
                          username: "#" + _vm.datasVisiteur.visiteurID,
                          size: "38px"
                        }
                      })
                    : !_vm.dejaEnChat && _vm.datasVisiteur.network
                    ? _c("wz-avatar", {
                        staticClass: "pl-1",
                        attrs: {
                          src: _vm.datasVisiteur.profile_pic,
                          username: _vm.datasVisiteur.visiteurName,
                          size: "38px"
                        }
                      })
                    : !_vm.dejaEnChat &&
                      !_vm.istypingVisiteur &&
                      _vm.visiteurLastMessage &&
                      _vm.datasVisiteur.visiteurID != _vm.visSelectId
                    ? _c("wz-avatar", {
                        attrs: {
                          username: "#" + _vm.datasVisiteur.visiteurID,
                          size: "38px",
                          lastMessage: ""
                        }
                      })
                    : !_vm.dejaEnChat && _vm.istypingVisiteur
                    ? _c("wz-avatar", {
                        attrs: {
                          isTyping: _vm.istypingVisiteur,
                          username: "#" + _vm.datasVisiteur.visiteurID,
                          size: "38px",
                          chip: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dejaEnChat &&
                  !_vm.istypingVisiteur &&
                  !_vm.visiteurLastMessage &&
                  _vm.datasVisiteur.visiteurID != _vm.visSelectId
                    ? _c("wz-avatar-double", {
                        attrs: {
                          avatars: [
                            {
                              id: _vm.datasVisiteur.visiteurName,
                              isTyping: false,
                              chip: true,
                              lastMessage: _vm.visiteurLastMessage
                            },
                            {
                              id: _vm.dejaEnChat.agentID,
                              username: _vm.dejaEnChat.agentName
                            }
                          ]
                        }
                      })
                    : _vm.dejaEnChat &&
                      !_vm.istypingVisiteur &&
                      !_vm.visiteurLastMessage &&
                      _vm.datasVisiteur.visiteurID == _vm.visSelectId
                    ? _c("wz-avatar-double", {
                        attrs: {
                          avatars: [
                            {
                              id: _vm.datasVisiteur.visiteurName,
                              isTyping: false,
                              chip: true,
                              lastMessage: _vm.visiteurLastMessage
                            },
                            {
                              id: _vm.dejaEnChat.agentID,
                              username: _vm.dejaEnChat.agentName
                            }
                          ]
                        }
                      })
                    : _vm.dejaEnChat &&
                      !_vm.istypingVisiteur &&
                      _vm.visiteurLastMessage &&
                      _vm.datasVisiteur.visiteurID != _vm.visSelectId
                    ? _c("wz-avatar-double", {
                        attrs: {
                          avatars: [
                            {
                              id: _vm.datasVisiteur.visiteurName,
                              isTyping: false,
                              chip: true,
                              lastMessage: _vm.visiteurLastMessage
                            },
                            {
                              id: _vm.dejaEnChat.agentID,
                              username: _vm.dejaEnChat.agentName
                            }
                          ]
                        }
                      })
                    : _vm.dejaEnChat && _vm.istypingVisiteur
                    ? _c("wz-avatar-double", {
                        attrs: {
                          avatars: [
                            {
                              id: _vm.datasVisiteur.visiteurName,
                              isTyping: true,
                              chip: true
                            },
                            {
                              id: _vm.dejaEnChat.agentID,
                              username: _vm.dejaEnChat.agentName
                            }
                          ]
                        }
                      })
                    : _vm.datasVisiteur.network
                    ? _c("wz-avatar-double", {
                        attrs: {
                          avatars: [
                            {
                              id: _vm.dejaEnChat.sessionID,
                              username: _vm.datasVisiteur.visiteurName,
                              src: _vm.datasVisiteur.profile_pic
                            },
                            {
                              id: _vm.dejaEnChat.agentID,
                              username: _vm.dejaEnChat.agentName
                            }
                          ]
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs8: "" } },
                    [
                      _c(
                        "v-list-tile-content",
                        [
                          _c(
                            "v-list-tile-title",
                            [
                              _c("v-tooltip", { attrs: { bottom: "" } }, [
                                _vm.datasVisiteur.nb_alert &&
                                _vm.datasVisiteur.nb_alert != 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "wz_alertFiltre secondary lighten-1 white--text",
                                        attrs: { slot: "activator" },
                                        slot: "activator"
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(_vm.datasVisiteur.nb_alert)
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _vm._v(
                                      "\n                    Filtre activé : "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm._l(_vm.listeAlerte, function(
                                      alerte,
                                      index
                                    ) {
                                      return _c("div", { key: index }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(index) +
                                            " - " +
                                            _vm._s(alerte)
                                        ),
                                        _c("br")
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _vm.datasVisiteur.nbCustomAlert &&
                              _vm.datasVisiteur.nbCustomAlert != 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "wz_alertPanier green lighten-1 white--text"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.datasVisiteur.nbCustomAlert
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "wz_nameVisiteur" }, [
                                _vm._v(_vm._s(_vm.datasVisiteur.shortdesc))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.datasVisiteur.pagesFocus
                            ? _c("v-list-tile-sub-title", [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.datasVisiteur.pagesFocus))
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.brideMenu("stats_leads_chaleur") === "1" &&
                  !_vm.searchVisitor
                    ? _c(
                        "v-flex",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.visSelectId &&
                                _vm.$vuetify.breakpoint.lgAndUp,
                              expression:
                                "!visSelectId && $vuetify.breakpoint.lgAndUp"
                            }
                          ],
                          staticClass: "iconesListeVisiteurs text-xs-center"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "secondary--text txtIcone txtMedium"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.datasVisiteur.ponderation) + "°"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            { attrs: { bottom: "" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "grey--text text--lighten-1",
                                  attrs: { slot: "activator", large: "" },
                                  slot: "activator"
                                },
                                [_vm._v("network_check")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.$t("leadHeat")))])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.searchVisitor
                    ? _c(
                        "v-flex",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.visSelectId &&
                                _vm.$vuetify.breakpoint.mdAndUp,
                              expression:
                                "!visSelectId && $vuetify.breakpoint.mdAndUp"
                            }
                          ],
                          staticClass: "iconesListeVisiteurs text-xs-center"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "secondary--text txtIcone txtMedium"
                            },
                            [_vm._v(_vm._s(_vm.visiteurAutoInvitSend))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            { attrs: { bottom: "" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "grey--text text--lighten-1",
                                  attrs: { slot: "activator", large: "" },
                                  slot: "activator"
                                },
                                [_vm._v("local_offer")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("cap")(_vm.$t("lastInvitAuto")))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.searchVisitor
                    ? _c(
                        "v-flex",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.visSelectId &&
                                _vm.$vuetify.breakpoint.smAndUp,
                              expression:
                                "!visSelectId && $vuetify.breakpoint.smAndUp"
                            }
                          ],
                          staticClass: "iconesListeVisiteurs text-xs-center"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "secondary--text txtIcone txtMedium"
                            },
                            [_vm._v(_vm._s(_vm.datasVisiteur.lang))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "grey--text text--lighten-1",
                              attrs: { large: "" }
                            },
                            [_vm._v("language")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.searchVisitor
                    ? _c(
                        "v-flex",
                        { staticClass: "iconesListeVisiteurs text-xs-center" },
                        [
                          _vm.visSelectId == _vm.datasVisiteur.visiteurID
                            ? _c(
                                "v-icon",
                                {
                                  staticClass:
                                    "secondary--text text--lighten-1",
                                  attrs: { large: "" }
                                },
                                [_vm._v("textsms")]
                              )
                            : _vm.visiteurLastChat != null
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.datasVisiteur
                                              .alreadyConsulted == 1 &&
                                            !_vm.visSelectId,
                                          expression:
                                            "datasVisiteur.alreadyConsulted == 1 && !visSelectId"
                                        }
                                      ],
                                      staticClass:
                                        "secondary--text txtIcone txtMedium"
                                    },
                                    [_vm._v(_vm._s(_vm.visiteurLastChat))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass:
                                            "grey--text text--lighten-1",
                                          attrs: {
                                            slot: "activator",
                                            medium: ""
                                          },
                                          slot: "activator"
                                        },
                                        [_vm._v("chat_bubble")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("lastMessageSent"))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _c("v-icon", {
                                staticClass: "grey--text text--lighten-1",
                                attrs: { medium: "" }
                              })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.searchVisitor
                    ? _c(
                        "v-flex",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.visSelectId &&
                                _vm.$vuetify.breakpoint.mdAndUp,
                              expression:
                                "!visSelectId && $vuetify.breakpoint.mdAndUp"
                            }
                          ],
                          staticClass: "text-xs-center"
                        },
                        [
                          _c(
                            "v-tooltip",
                            { attrs: { bottom: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    flat: "",
                                    icon: "",
                                    color: "accent"
                                  },
                                  on: { click: _vm.stopAlert },
                                  nativeOn: {
                                    mouseover: function($event) {
                                      _vm.overMenu = true
                                    },
                                    mouseleave: function($event) {
                                      _vm.overMenu = false
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "grey--text text--lighten-1",
                                      attrs: { large: "" }
                                    },
                                    [_vm._v("beenhere")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("disableAutoInvitation")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-chip",
            {
              class: {
                "light-blue lighten-4":
                  _vm.visSelectId == _vm.datasVisiteur.visiteurID
              },
              on: { click: _vm.checkChatVisiteur }
            },
            [
              _vm.datasVisiteur.network
                ? _c("wz-avatar", {
                    attrs: {
                      src: _vm.datasVisiteur.profile_pic,
                      username: _vm.datasVisiteur.visiteurName,
                      size: "26px",
                      chip: ""
                    }
                  })
                : !_vm.istypingVisiteur &&
                  _vm.visiteurLastMessage &&
                  _vm.datasVisiteur.visiteurID != _vm.visSelectId
                ? _c("wz-avatar", {
                    attrs: {
                      username: "#" + _vm.datasVisiteur.visiteurID,
                      size: "26px",
                      lastMessage: ""
                    }
                  })
                : _c("wz-avatar", {
                    attrs: {
                      isTyping: _vm.istypingVisiteur,
                      username: "#" + _vm.datasVisiteur.visiteurID,
                      size: "26px",
                      chip: ""
                    }
                  }),
              _vm._v(" "),
              _vm.istypingVisiteur && !_vm.visiteurLastMessage
                ? _c("span", { staticClass: "wz_decalIdentity" }, [
                    _vm._v("\n        " + _vm._s(_vm.identity) + "\n      ")
                  ])
                : _vm.istypingVisiteur && _vm.visiteurLastMessage
                ? _c("span", { staticClass: "wz_decalIdentity" }, [
                    _vm._v("\n        " + _vm._s(_vm.identity) + "\n      ")
                  ])
                : !_vm.istypingVisiteur &&
                  _vm.visiteurLastMessage &&
                  _vm.visSelectId != _vm.datasVisiteur.visiteurID
                ? _c("span", { staticClass: "wz_nameLastMessage" }, [
                    _vm._v("\n        " + _vm._s(_vm.identity) + " "),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [_vm._v(_vm._s(_vm.visiteurLastMessage))])
                  ])
                : _c("span", [
                    _vm._v("\n        " + _vm._s(_vm.identity) + "\n      ")
                  ]),
              _vm._v(" "),
              _vm.dejaEnChat
                ? _c("wz-avatar", {
                    staticClass: "avatarChipRight",
                    attrs: {
                      src:
                        _vm.domaine +
                        "/public/media/user/small/" +
                        _vm.dejaEnChat.agentID +
                        "_avatar.jpg",
                      username: _vm.dejaEnChat.agentName
                    }
                  })
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      _vm.dejaEnChat
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: _vm.dialogDejaEnChat,
                callback: function($$v) {
                  _vm.dialogDejaEnChat = $$v
                },
                expression: "dialogDejaEnChat"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "primary white--text subheading" },
                    [_vm._v(_vm._s(_vm.$t("conversationInProgress")) + " !")]
                  ),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tc("conversationInProgressWith", 1, {
                              count: _vm.dejaEnChat.agentName
                            })
                          )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.emitOpenChat()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("yes")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogDejaEnChat = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("no")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53cbaee9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53cbaee9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzWatcheeboxVisiteur.vue
// module id = null
// module chunks = 